import React from 'react'
import { Link } from "react-router-dom";
import { UserContext } from '../../Context/UserContext';
import { Flex, Text, Icon, useColorModeValue } from '@chakra-ui/react';

export function ItemMenu({link, title, icon}) {
    const { onClose } = React.useContext(UserContext);
    
    // Cores dinâmicas para o tema premium
    const hoverBg = useColorModeValue('brand.50', 'whiteAlpha.100');
    const hoverColor = useColorModeValue('brand.600', 'brand.300');
    const iconColor = useColorModeValue('gray.500', 'gray.400');
    const textColor = useColorModeValue('gray.700', 'whiteAlpha.900');

    return (
        <Link to={link} style={{ textDecoration: 'none' }}>
            <Flex 
                align='center' 
                gap='3' 
                p='3' 
                borderRadius="xl"
                transition="all 0.2s"
                role="group"
                _hover={{ 
                    bg: hoverBg,
                    transform: 'translateX(5px)',
                    color: hoverColor
                }} 
                onClick={onClose}
            >
                <Icon 
                    as={icon} 
                    w='5' 
                    h='5' 
                    color={iconColor}
                    _groupHover={{ color: hoverColor }}
                />
                <Text 
                    fontWeight="600" 
                    fontSize="sm" 
                    color={textColor}
                    _groupHover={{ color: hoverColor }}
                >
                    {title}
                </Text>
            </Flex>
        </Link>
    );
}

export default ItemMenu;